import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Lock, BookOpen, Zap, ShoppingCart, Utensils, Map, LifeBuoy, Coffee, Sparkles, ShieldCheck, Download, CheckCircle2 } from 'lucide-react';
interface OfferItem {
  icon: React.ReactNode;
  text: string;
  value: string;
  isBonus?: boolean;
}
const items: OfferItem[] = [{
  icon: <BookOpen className="w-5 h-5" strokeWidth={1.75} data-id="element-258" />,
  text: 'Guía Aplicada: Plan Antinflamatorio 15-Min — Edición Chile',
  value: '$9.990'
}, {
  icon: <Zap className="w-5 h-5" strokeWidth={1.75} data-id="element-259" />,
  text: 'Protocolo Reset 72h — Deshinchazón Express',
  value: '$5.990'
}, {
  icon: <ShoppingCart className="w-5 h-5" strokeWidth={1.75} data-id="element-260" />,
  text: 'Lista de Compras "Zero Estrés" — Directo al súper',
  value: '$3.990'
}, {
  icon: <Utensils className="w-5 h-5" strokeWidth={1.75} data-id="element-261" />,
  text: 'Recetario Express — Recetas chilenas en menos de 15 min',
  value: '$4.990'
}, {
  icon: <Map className="w-5 h-5" strokeWidth={1.75} data-id="element-262" />,
  text: 'BONO 1: Mapa Fuego Cero del Súper — Guía visual por pasillo',
  value: '$6.990',
  isBonus: true
}, {
  icon: <LifeBuoy className="w-5 h-5" strokeWidth={1.75} data-id="element-263" />,
  text: 'BONO 2: SOS Abdomen 24 Horas — Protocolo de emergencia express',
  value: '$6.990',
  isBonus: true
}, {
  icon: <Coffee className="w-5 h-5" strokeWidth={1.75} data-id="element-264" />,
  text: 'BONO 3: La Once Inteligente — 7 opciones chilenas sin inflamación',
  value: '$8.990',
  isBonus: true
}];
const TOTAL_REAL = '$47.930 CLP';
const PRICE_TODAY = '$14.990';
export function Offer() {
  return <section id="offer" className="py-14 md:py-16 bg-brand-cream relative" data-id="element-265">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-266">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-brand-gold/20" data-id="element-267">
          {/* ======================================================
           Header
           ====================================================== */}
          <div className="bg-brand-navy px-6 sm:px-10 py-10 md:py-14 text-center relative overflow-hidden" data-id="element-268">
            <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiPgo8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSIjMEIxRTNGIj48L3JlY3Q+CjxwYXRoIGQ9Ik0wIDBMOCA4Wk04IDBMMCA4WiIgc3Ryb2tlPSIjMUQzNTY0IiBzdHJva2Utd2lkdGg9IjEiPjwvcGF0aD4KPC9zdmc+')] opacity-20" data-id="element-269"></div>

            <h2 className="relative z-10 text-3xl md:text-4xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-270">
              Recupera tu figura y tu bienestar{' '}
              <span className="text-brand-gold" data-id="element-271">hoy mismo.</span>
            </h2>
            <p className="relative z-10 text-brand-cream/85 text-base sm:text-lg max-w-2xl mx-auto" data-id="element-272">
              Olvida las dietas fallidas y toma el control de tu salud con
              herramientas que funcionan en la realidad chilena.
            </p>
          </div>

          {/* ======================================================
           Body
           ====================================================== */}
          <div className="px-5 sm:px-10 py-10" data-id="element-273">
            <div className="mb-6 text-center" data-id="element-274">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-brand-navy" data-id="element-275">
                Tu acceso incluye:
              </h3>
              <div className="w-16 h-1 bg-brand-gold mx-auto mt-3 rounded-full" data-id="element-276" />
            </div>

            {/* Itemized list */}
            <ul className="rounded-2xl border border-brand-navy/10 overflow-hidden divide-y divide-brand-navy/10 mb-6" data-id="element-277">
              {items.map((item, i) => <li key={i} className={`relative grid grid-cols-[auto_1fr_auto] gap-3 sm:gap-4 px-4 sm:px-6 py-4 items-center ${item.isBonus ? 'bg-brand-gold/[0.05]' : 'bg-white'}`} data-id="element-278">
                  {item.isBonus && <span className="absolute left-0 top-0 bottom-0 w-1 bg-brand-gold" data-id="element-279" />}

                  {/* Icon */}
                  <div className={`shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-lg ${item.isBonus ? 'bg-brand-gold/15 text-brand-gold' : 'bg-brand-navy/5 text-brand-navy'}`} data-id="element-280">
                    {item.icon}
                  </div>

                  {/* Text */}
                  <div className="min-w-0" data-id="element-281">
                    <p className="text-sm sm:text-base text-brand-navy leading-snug" data-id="element-282">
                      {item.text}
                    </p>
                    {item.isBonus && <span className="inline-flex items-center gap-1 mt-1 bg-brand-gold text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full" data-id="element-283">
                        <Sparkles className="w-3 h-3" data-id="element-284" /> Bono incluido
                      </span>}
                  </div>

                  {/* Value */}
                  <span className="font-serif font-bold text-base sm:text-lg text-brand-navy shrink-0" data-id="element-285">
                    {item.value}
                  </span>
                </li>)}
            </ul>

            {/* ======================================================
             Totals block
             ====================================================== */}
            <div className="rounded-2xl overflow-hidden border border-brand-gold/30 mb-6" data-id="element-286">
              {/* Strikethrough total */}
              <div className="grid grid-cols-[1fr_auto] gap-3 px-5 sm:px-7 py-4 items-center bg-brand-cream/50" data-id="element-287">
                <span className="text-xs sm:text-sm font-bold uppercase tracking-wider text-brand-navy/60" data-id="element-288">
                  Valor total real
                </span>
                <span className="font-serif font-bold text-lg sm:text-xl text-gray-400 line-through" data-id="element-289">
                  {TOTAL_REAL}
                </span>
              </div>

              {/* Investment today */}
              <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-3 px-5 sm:px-7 py-6 items-center bg-brand-navy" data-id="element-290">
                <div className="flex items-center gap-2" data-id="element-291">
                  <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-292" />
                  <span className="text-sm sm:text-base font-bold uppercase tracking-wider text-brand-cream" data-id="element-293">
                    Tu inversión hoy
                  </span>
                </div>
                <div className="flex items-baseline gap-2 sm:justify-end" data-id="element-294">
                  <span className="font-serif font-bold text-3xl sm:text-4xl text-brand-gold leading-none" data-id="element-295">
                    {PRICE_TODAY}
                  </span>
                  <span className="text-base font-bold text-brand-cream" data-id="element-296">
                    CLP
                  </span>
                </div>
              </div>
            </div>

            {/* Conditions row */}
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-brand-navy/70 mb-6 text-center" data-id="element-297">
              <span className="flex items-center gap-1" data-id="element-298">
                <CheckCircle2 className="w-4 h-4 text-brand-green" data-id="element-299" /> Pago único
              </span>
              <span className="opacity-30 hidden sm:inline" data-id="element-300">·</span>
              <span className="flex items-center gap-1" data-id="element-301">
                <Download className="w-4 h-4 text-brand-green" data-id="element-302" /> Acceso
                inmediato
              </span>
              <span className="opacity-30 hidden sm:inline" data-id="element-303">·</span>
              <span className="flex items-center gap-1" data-id="element-304">
                <Lock className="w-4 h-4 text-brand-green" data-id="element-305" /> Sin letra chica
              </span>
            </div>

            {/* Anchor line */}
            <p className="text-center text-sm sm:text-base italic text-brand-navy/70 max-w-xl mx-auto mb-6" data-id="element-306">
              Por menos de lo que gastas en{' '}
              <span className="font-semibold not-italic text-brand-navy" data-id="element-307">
                una semana de supermercado mal invertida.
              </span>
            </p>

            {/* Guarantee strip */}
            <div className="flex items-start sm:items-center gap-3 bg-brand-green/10 border border-brand-green/30 rounded-2xl p-4 sm:p-5 mb-8" data-id="element-308">
              <div className="shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-brand-green flex items-center justify-center" data-id="element-309">
                <ShieldCheck className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-310" />
              </div>
              <div className="min-w-0" data-id="element-311">
                <p className="font-bold text-brand-navy text-sm sm:text-base" data-id="element-312">
                  Garantía total de 7 días
                </p>
                <p className="text-xs sm:text-sm text-brand-navy/75 leading-snug mt-0.5" data-id="element-313">
                  Si no notas ninguna diferencia, te devolvemos tu dinero sin
                  preguntas.
                </p>
              </div>
            </div>

            {/* CTA */}
            <Button checkout fullWidth className="text-base sm:text-lg py-5 shadow-xl shadow-brand-gold/20" data-id="element-314">
              ¡SÍ, QUIERO DESINFLAMAR MI ABDOMEN AHORA!
            </Button>

            {/* Trust line */}
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-5 text-xs text-brand-navy/60" data-id="element-315">
              <span className="flex items-center gap-1" data-id="element-316">
                <Lock className="w-3.5 h-3.5" data-id="element-317" />
                Compra segura
              </span>
              <span className="opacity-30" data-id="element-318">·</span>
              <span className="flex items-center gap-1" data-id="element-319">
                <Download className="w-3.5 h-3.5" data-id="element-320" />
                Descarga digital instantánea
              </span>
              <span className="opacity-30" data-id="element-321">·</span>
              <span className="flex items-center gap-1" data-id="element-322">
                <ShieldCheck className="w-3.5 h-3.5" data-id="element-323" />
                Garantía 7 días
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}